import React, { useState, useEffect } from 'react';
import Modal from 'rsuite/Modal';
import NewEmpresaForm from 'Components/Admin/Empresa/NewEmpresa/NewEmpresaForm';
import PropTypes from 'prop-types';

export default function NewEmpresaModal(props) {
  const {isOpen, setOpen, data, isEdit} = props;
  const [formData, setFormData] = useState(null);

  const handleClose = () => {
    if(!isEdit)
      setFormData(null);
    setOpen(false);
  }

  useEffect(() => {
    if(isEdit)
      setFormData(data);
    else setFormData(null)
  }, [data, isEdit])

  return (
    <>
      <Modal size="md" open={isOpen} onClose={handleClose} backdrop='static'>
        <Modal.Header>
          <Modal.Title>{formData && formData.nit? 'Actualizar': 'Nuevo'} Emisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewEmpresaForm data={formData} close={handleClose} />
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  );
}

NewEmpresaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object,
}